<style lang="sass" scoped>
  .hovering
    .fake-data // Show message when hovering
      opacity: 1
      -webkit-transition: opacity 0.5s ease-in-out
      -moz-transition: opacity 0.5s ease-in-out
      -ms-transition: opacity 0.5s ease-in-out
      -o-transition: opacity 0.5s ease-in-out
      transition: opacity 0.5s ease-in-out

  .fake-data
    // pointer-events: none
    opacity: 0
    top: 50%
    left: 50%
    margin-top: -125px
    margin-left: -300px
    position: absolute
    height: 250px
    width: 600px
    border-radius: 30px
    z-index: 2
    text-align: center

    h2
      font-size: 1.375rem
      font-weight: bold
      margin-bottom: 0.75rem

    h3
      font-size: 1.125rem
      font-weight: 400
      margin-bottom: 0.75rem

    p
      margin: 1.25rem 0
</style>

<template>
  <div :class="{ hovering }">
    <div
      class="fake-data"
      :style="{ zoom: zoom || 1 }"
    >
      <h2>{{ __('Você ainda não tem dados a serem exibidos!') }}</h2>
      <h3>{{ __('Esses dados são fictícios. Mas poderiam ser seus.') }}</h3>
      <p v-html="__(content)" /><a
        class="btn btn-green"
        :href="href"
      >{{ __(cta) }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['zoom', 'hovering', 'content', 'cta', 'href'],
};
</script>
